import React, { useMemo } from 'react'
import { buildRoomPackageOptionsViewOrder } from 'lib/offer/offerPageUtil'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getDurationPackageOptions } from 'selectors/offerPage/offerPageSelectors'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import AccommodationRoomTile from 'components/AccommodationKit/AccommodationRoomTile'
import AccommodationRoomTileImage from 'components/AccommodationKit/AccommodationRoomTileImage'
import AlwaysOnAboutRoomModalTab from './AlwaysOnAboutRoomModalTab'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import ModalBase from 'LuxKit/Modal/ModalBase'

interface Props {
  room: App.PackageRoomType
  packageOptions: Array<App.OfferPackageOptionView>
  onClose?: () => void
}

function AlwaysOnRoomDetailsModal(props: Props) {
  const {
    room,
    packageOptions,
  } = props

  const packageOptionsByRoom = useMemo(() => {
    return buildRoomPackageOptionsViewOrder(packageOptions)
  }, [packageOptions])

  const packageViews = packageOptionsByRoom.find(option => option.roomId === room.id)?.packageViews
  const pkg = packageViews?.[0].package!

  return (
    <ModalBase mode="drawer">
      <ModalHeader
        title={room.name}
      />
      <ModalBody>
        <AccommodationRoomTile roomPackage={pkg}>
          <AccommodationRoomTileImage roomPackage={pkg} />
        </AccommodationRoomTile>
        <AlwaysOnAboutRoomModalTab pkg={pkg} />
      </ModalBody>
    </ModalBase>
  )
}

export default withOfferPageAndReduxState((state: OfferPageState, appState: App.State) => ({
  packageOptions: getDurationPackageOptions(state, appState),
}), AlwaysOnRoomDetailsModal)
